export const stripBrandForClassName = (brand: any) => {
  return brand
    .toLowerCase()
    .replace(/\s|-|motor-?cycles?/g, '')
    .replace(/ë/g, 'e')
}
